import React from "react";
import ProductItems from "../components/ProductItems";

export default function Shop(...props) {
    return (
        <div className="Courses">
            <div className="AppContainer">
                <h1 className="SectionTitle">Shop</h1>
                <ProductItems />
            </div>
        </div>
    );
}
